<div class="ui-tab w-100 h-100 flex-col gap-16">
    <div class="flex-row space-between-center">
        <!-- FILTERS -->
        <div *ngIf="selectIsLoadedSig()"
             class="flex-row start-center gap-16">
            <ui-search style="width: 320px"
                       [searchQuery]="search()"
                       (onInput)="search.set($event)"
                       [placeholder]="'COMMON.SEARCH'|translate"></ui-search>

            <ui-camera-select-button (click)="selectCamera()"></ui-camera-select-button>

            <app-tag-filter [formControl]="tagIdsFilter"
                            [isCreateButtonVisibleSig]="false">></app-tag-filter>
        </div>

        <ui-button *ngIf="selectIsLoadedSig()"
                   [text]="'DATABASE_TAGS.BUTTONS.CREATE'|translate"
                   [disabled]="(selectIsLoadingSig() || selectIsSavingSig())"
                   (click)="create()">
        </ui-button>
    </div>

    <!-- FILTER CHIPS -->
    <ng-container
                  *ngIf="(cameraIdsFilter.value && Object.keys(cameraIdsFilter.value).length) || search() || tagIdsFilter.value.length">
        <div class="flex-row gap-8 start-center">
            <span class="ui-icon-cross c-p"
                  [matTooltip]="'COMMON.CLEAR_FILTERS'|translate"
                  (click)="cleanAllFilters()">
            </span>

            <!-- SEARCH CHIPS -->
            <ng-container *ngIf="search()">
                <ui-filter-chip [title]="search()"
                                (removeClicked)="search.set(null)">

                </ui-filter-chip>
            </ng-container>

            <!-- CAMERA CHIPS -->
            <ng-container *ngIf="cameraIdsFilter.value && Object.keys(cameraIdsFilter.value).length">
                <div [matMenuTriggerFor]="camerasMenu"
                     class="filter-chip camera-chip">
                    <ui-filter-chip class="filter-chip"
                                    [title]="(Object.values(cameraIdsFilter.value))?.length + ' ' + ('WALL_LIST.CAMERA_FILTER'|translate)"
                                    [allowDelete]="false"></ui-filter-chip>
                </div>

                <mat-menu #camerasMenu="matMenu"
                          xPosition="after"
                          yPosition="below"
                          class="property-chips-wrapper">
                    <div class="flex-row flex-wrap gap-8 property-chips">

                        <ng-container *ngFor="let camera of Object.values(cameraIdsFilter.value)">
                            <ui-filter-chip class="filter-chip"
                                            [title]="selectCamerasSig()[camera.cameraId].edgeOnly.name"
                                            [allowDelete]="true"
                                            (removeClicked)="onRemoveCamera(camera.cameraId)">
                            </ui-filter-chip>
                        </ng-container>
                    </div>
                </mat-menu>
            </ng-container>

            <!-- TAGS CHIPS -->
            <ng-container *ngFor="let tagId of tagIdsFilter.value">
                <ui-filter-chip [title]="(selectDatabaseTagsEntitiesSig()[tagId])?.name"
                                (removeClicked)="cleanTagsFilterControl(tagId)">
                </ui-filter-chip>
            </ng-container>
        </div>
    </ng-container>

    <!-- TABLE -->
    <div class="h-100 min-h-0">
        <ng-container *ngIf="!(selectIsLoadingSig() || selectIsSavingSig()); else loader">
            <ng-container *ngIf="selectShelfsSig()?.length && tableConfig(); else noDataResult">
                <ui-dataset-table [data]="selectShelfsSig()"
                                  [config]="tableConfig()!"
                                  (rowAction)="onRowAction($event)"
                                  (loadMore)="onLoadMore()"></ui-dataset-table>
            </ng-container>
        </ng-container>
    </div>

    <!-- CELL TEMPLATES -->
    <ng-template #nameCell
                 let-row>
        <div class="flex-row start-center gap-8">
            <div class="camera-snapshot">
                <ui-camera-snapshot [cameraId]="row.cameraId"
                                    [edgeId]="row.location?.edgeId">
                </ui-camera-snapshot>
            </div>
            <div>{{ row.name }}</div>
        </div>
    </ng-template>

    <ng-template #tagsCell
                 let-row>
        @if (row.tags?.length) {
        <tag-menu [tags]="row.tags"
                  [tooltip]="'DATABASE_TAGS.SHELF_TOOLTIP'">
        </tag-menu>
        } @else {
        <span class="no-tags">—</span>
        }
    </ng-template>
</div>

<ng-template #noDataResult>
    <ng-container
                  *ngIf="(cameraIdsFilter.value && Object.keys(cameraIdsFilter.value).length) || search() || tagIdsFilter.value.length; else noData">
        <ui-no-data [imgSrc]="noResults.imgSrc"
                    [title]="noResults.title|translate">
        </ui-no-data>
    </ng-container>
</ng-template>

<ng-template #noData>
    <ui-no-data [imgSrc]="noDataObj.imgSrc"
                [title]="noDataObj.title|translate">
    </ui-no-data>
</ng-template>

<ng-template #loader>
    <ui-preloader [color]="loaderColor.blue"
                  style="padding: 100px 0;"></ui-preloader>
</ng-template>